import React from 'react';
import { ProfileStep2 } from 'components/newAccountSteps/profileSteps/profileStep2/profileStep2';
import { ProfileStep2Reduced } from 'components/newAccountSteps/profileSteps/profileStep2Reduced';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { ProfileOpenCredit } from 'components/newAccountSteps/profileSteps/profileOpenCredit';
import { StandByHC } from 'components/newAccountSteps/profileSteps/standByHC';
import { CardSelectorViewContainer } from 'components/newAccountSteps/profileSteps/cardSelectorView/cardSelectorViewContainer';
import { DEBIT_CARD, WAITING } from 'constants/statusProcess';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

export const ProfileView = ({ status, jointHolderType, showOpenCredit, fetchSuccess, products }) => {
    if (fetchSuccess && status === WAITING) {
        return <StandByHC />;
    }

    if (getIsAuthorized(jointHolderType)) {
        return (
            <div className="profesional-data-view">
                <ProfileStep2Reduced />
                <WelcomeCard />
            </div>
        );
    }

    if (showOpenCredit) {
        return (
            <div className="profesional-data-view">
                <ProfileOpenCredit />
                <WelcomeCard />
            </div>
        );
    }
    if (status === DEBIT_CARD) {
        return (
            <div>
                <CardSelectorViewContainer products={products} />
                <WelcomeCard />
            </div>
        );
    }

    return (
        <div className="profesional-data-view">
            {<ProfileStep2 />}
            <WelcomeCard />
        </div>
    );
};
